Modal.prototype._hide = Modal.prototype.hide;

Modal.prototype.hide = function () {
  if (document.activeElement) {
    document.activeElement.blur();
  }
  this._hide();
};

Modal.prototype._createBackdrop = function () {
  var _a;
  if (this._isHidden) {
    var backdropEl = document.createElement('div');
    var backdropWrapper = document.createElement('div');
    backdropWrapper.setAttribute('class', 'thq-tw-application');
    backdropEl.setAttribute('data-modal-backdrop', '');
    backdropEl.setAttribute('id', this._instanceId + '-backdrop');
    (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(' '));
    document.querySelector('body').append(backdropWrapper);
    backdropWrapper.appendChild(backdropEl);
    this._backdropEl = backdropEl;
  }
};

Modal.prototype._destroyBackdropEl = function () {
  var backdropEl = document.querySelector('#' + this._instanceId + '-backdrop');
  if (backdropEl && this._targetEl.getAttribute('aria-hidden') === 'true') {
    backdropEl.parentElement.remove();
  }
};
